<template>
    <div class="workOrderList">
        <div class="clearfix fixed">
            <van-nav-bar
                class="restclass"
                title="待修故障列表"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>
        <div class="clientList">
            <van-row class="search">
                <van-col span="20"><van-search v-model="payload.keyword" placeholder="请输入搜索关键词" class="search" /></van-col>
                <van-col span="2">
                    <van-button type="primary" size="normal" round style="font-size:13px;margin-top:8px;"
                        @click="search">查&nbsp;询</van-button>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="4">
                    <van-button type="primary" size="normal" round style="font-size:13px;margin-top:-5px;"
                        @click="queryallList">全部</van-button>
                </van-col>
                <van-col span="20">
                    <van-dropdown-menu active-color="#ee0a24">
                        <van-dropdown-item v-model="payload.status" :options="statuss" @change="statusChange" />
                    </van-dropdown-menu>
                </van-col>
            </van-row>
            <van-list
                v-model="fansLoading"
                :finished="fansFinished"
                finished-text="已加载全部"
                @load="loadMore">
                <div
                    v-for="(item,index) in list"
                    :key="item.Id"
                    class="list clearfix">
                    <!-- @click="onClientDetails(item.TerminalId,item.SN)" -->
                    <div class="clearfix">
                        <van-row>
                            <van-col span="1">{{ index + 1 }}</van-col>
                            <van-col span="20">
                                <p>
                                    <span class="info-span">{{ item.sheetStatus }}</span>
                                    <span class="info-span-red" @click="jumpDispatchList(item.id)">{{ item.sheetNo }}</span>
                                </p>
                                <p>
                                    <span class="info-span">{{ item.owner }}</span>
                                    <span class="info-span">{{ item.maintainItem }}</span>
                                    <span class="info-span">{{ item.category + "-" + item.barCode }}</span>
                                </p>
                            </van-col>
                            <van-col v-if="$_has('maintain:faultlist:edit')" span="3"><van-button type="primary" round @click="queryDispatch(item.workOrderItemId)">派工</van-button></van-col>
                            <!-- <van-col span="1"><span calss="info-span-red">{{ statusTranslate(item.enumWorkOrderStatus) }}</span></van-col> -->
                        </van-row>
                    </div>
                </div>
            </van-list>
            <p
                v-if="list.length === 0"
                class="noList">暂无数据</p>
        </div>
        <bottom />
    </div>
</template>

<script>
// import { Icon, List, Button, Col, Row, DropdownMenu, DropdownItem, Search } from 'vant'
import bottom from '@/components/bottom'
import { WorkOrderawmList } from '@/api/maintain'
export default {
    name: 'FaultRepaired',
    components: {
        bottom
        // Icon, List, [Button.name]: Button, [Col.name]: Col, Row, DropdownMenu, DropdownItem, Search
    },
    data() {
        return {
            fansLoading: false,
            fansFinished: false,
            payload: { status: 0, pageIndex: 1, pageSize: 10 },
            list: [],
            totalCount: 0,
            status: 0,
            category: 0,
            statuss: [
                { value: 0, text: '全部' },
                { value: 1, text: '缺件' },
                { value: 2, text: '客户终止' }
            ]
        }
    },
    created() {
    },
    mounted() {
        this.init()
    },
    methods: {
        init: function() {
            this.queryList()
        },
        getBack() {
            this.$router.push({ path: '/' })
        },
        loadMore() {
            if (!this.fansFinished) {
                this.payload.pageIndex++
                this.fansLoading = true
                WorkOrderawmList(this.payload).then(response => {
                    this.list.push.apply(this.list, response.data)
                    this.totalCount = response.totalCount
                }).finally(this.afterLoad)
            }
        },
        search() {
            this.payload.pageIndex = 1
            this.queryList()
        },
        queryList() {
            this.fansLoading = true
            WorkOrderawmList(this.payload).then(response => {
                this.list = response.data
                this.totalCount = response.totalCount
            }).finally(this.afterLoad)
        },
        queryallList() {
            this.payload = {
                status: 0,
                pageIndex: 1,
                pageSize: 10
            }
            this.queryList()
        },
        statusChange() {},
        // statusTranslate(status) {
        //     var item = this.optionStatus.find(s => { return s.value == status })
        //     if (item) { return item.text }
        //     return status
        // },
        categoryChange() {},
        afterLoad() {
            this.fansLoading = false
            this.fansFinished = this.list.length == this.totalCount
        },
        // 列表的派工单号跳转到派工单
        jumpDispatchList(val) {
            if (val) {
                if (this.$_has('maintain:workorder:view')) {
                    this.$router.push({
                        path: '/dispatchList',
                        query: { id: val, type: '处理' }
                    })
                } else {
                    this.$router.push({
                        path: '/404'
                    })
                }
            }
        },
        queryDispatch(val) {
            if (val) {
                if (this.$_has('maintain:workorder:view')) {
                    this.$router.push({
                        path: '/faultrepairedDetails',
                        query: { id: val, type: '处理' }
                    })
                } else {
                    this.$router.push({
                        path: '/404'
                    })
                }
            }
        }
    }
}
</script>

<style lang='scss'  scoped>
.workOrderList {
    width: 100%;
  .logout{
    margin-top: -20px;
    color: blue;
  }
  .clientList{
    margin-bottom: 100px;
    padding: 0px 20px;
    .span-index{
        background:#07c160;border-radius:5px;color:#fff; margin-top:3px;text-align:center
    }
    h2{
      font-size: 32px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .search{
      margin:10px 0;
      button{
        width: 100px;
        height: 50px;
        color: #ffffff;
        margin-left: 10px;
        border-radius: 10px;
      }
    }
    .list{
      padding: 20px 0;
      //border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      h3{
        font-size: 38px;
        font-weight: 700;
      }
      .msg{
        padding: 20px 0;
        font-size: 18px;
        .phone{
          margin-left: 10%;
          color: #3498db;
        }
      }
      p{
        color: #999;
        font-size: 20px;
        padding: 5px 0;
      }
    }
  }
}
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.info-span {
    display:inline-block;
    padding:0px 8px;
    color:#000;
    width:30%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.info-span-red {
    padding:0px 8px;
    color:#f00;
}
.noList{
    text-align: center;
    margin-top: 50%;
    font-size: 26px;
    color: #ccc;
}
.listMore{
    text-align: center;
    font-size: 26px;
    color: rgb(204, 204, 204);
}
.right-top-box{
    width:100px;
    height:100px;
    background-color: #555;
    color: #fff;
    /* Rotate div */
    transform:rotate(45deg);
    ms-transform:rotate(45deg); /* Internet Explorer */
    moz-transform:rotate(45deg); /* Firefox */
    webkit-transform:rotate(45deg); /* Safari 和 Chrome */
    o-transform:rotate(45deg); /* Opera */

    position: absolute;
    right: -50px;
    top: -50px;
}
</style>
